export default {
  root: {
    margin: '0 5px',
    cursor: 'pointer'
  },
  tooltipPlacementBottom: { marginTop: '2px' }
};
